import type { RedeemableEntitlement } from '@/campaign-reward-types'

export function isPlayableInstantWinEntitlement(
  entitlement: RedeemableEntitlement
): boolean {
  return (
    entitlement.target_type === 'instant_win' &&
    !!entitlement.target_code &&
    entitlement.redeemable !== false
  )
}

export function isBlockedInstantWinEntitlement(
  entitlement: RedeemableEntitlement
): boolean {
  return (
    entitlement.target_type === 'instant_win' &&
    !!entitlement.target_code &&
    entitlement.redeemable === false
  )
}

export function firstPlayableInstantWinEntitlement<
  TEntitlement extends RedeemableEntitlement,
>(entitlements: Array<TEntitlement>): TEntitlement | null {
  return entitlements.find(isPlayableInstantWinEntitlement) ?? null
}

export function firstBlockedInstantWinEntitlement<
  TEntitlement extends RedeemableEntitlement,
>(entitlements: Array<TEntitlement>): TEntitlement | null {
  return entitlements.find(isBlockedInstantWinEntitlement) ?? null
}

export function firstBlockedEntitlementMessage(
  entitlements: Array<RedeemableEntitlement>
): string | null {
  return (
    entitlements.find((entitlement) => entitlement.redeemable === false)
      ?.redeem_block_message ?? null
  )
}

export function filterRedeemableEntitlements<
  TEntitlement extends RedeemableEntitlement,
>(entitlements: Array<TEntitlement>): Array<TEntitlement> {
  return entitlements.filter((entitlement) => entitlement.redeemable !== false)
}
